export default __webpack_public_path__ + "static/media/Prakruthi-Packers.a156642f.webp";